import styled, { css } from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  $type?:
    | 'line'
    | 'lineIcon'
    | 'lineDropdown'
    | 'blackLineIcon'
    | 'grayLineIcon'
    | 'black'
    | 'orange'
    | 'dropdown'
    | 'shortcut'
    | 'refresh'
    | 'grayDropdown'
    | 'transparentWhite'
    | undefined;
  $size?: 'medium' | 'large' | undefined;
  disabled?: boolean;
}

export const BasicBtn = styled(Button)<IProps>`
  &[disabled] {
    opacity: 0.5;
    pointer-events: none;
    background-color: #dddddd;
    border: 1px solid #dddddd;
    color: #fff;
  }

  height: 40px;
  padding: 0 20px;
  background-color: #fff;
  border: 1px solid #e2e2e2;
  color: #000;

  .text {
    ${mixin.flex({})}
    font-weight: 500;
    line-height: 130%;
    font-size: 14px;
    min-width: 130px;
  }

  .icon-arrow {
    margin-left: 7px;
    ${mixin.flex({})}
  }

  .icon-before + .text {
    margin-left: 10px;
    min-width: auto;
  }

  .icon-after {
    ${mixin.flex({})}
    margin-left: 4px;
  }

  .area-ellipsis {
    display: inline-block;
    ${mixin.ellipsis(1)};
    max-width: 114px;

    + .inner-text {
      display: inline-block;
      margin-left: 3px;
    }
  }

  ${props => {
    if (props.$size === 'large') {
      return css`
        height: 50px;
        padding: 0 40px;

        .text {
          font-size: 15px;
          min-width: 255px;
        }

        .icon-arrow {
          margin-left: 9px;
        }
      `;
    }
    return null;
  }}

  ${props => {
    if (props.$size === 'large' && props.$type === 'lineIcon') {
      return css`
        .icon-arrow svg {
          transform: rotate(90deg);
        }
      `;
    }
    if (props.$type === 'lineDropdown') {
      return css`
        width: 170px;

        .text {
          min-width: initial !important;
        }

        .icon-arrow {
          width: 14px;
          height: 14px;
          margin-left: 2px;

          svg {
            width: 100%;
            height: 100%;
            vertical-align: top;
          }
        }
      `;
    }
    if (props.$type === 'blackLineIcon') {
      return css`
        border: 1px solid #000;

        .icon-arrow svg {
          width: 7px;
          height: 10px;
        }
      `;
    }
    if (props.$type === 'grayLineIcon') {
      return css`
        border: 1px solid #e2e2e2;

        .text {
          font-weight: 600;
          min-width: unset;
        }

        .icon-arrow {
          margin-left: 7px;

          svg {
            width: 6px;
            height: 9px;
          }
        }
      `;
    }
    if (props.$type === 'black') {
      return css`
        border: 1px solid #000;
        background-color: #000;
        color: #fff;
      `;
    }
    if (props.$type === 'orange') {
      return css`
        border: 1px solid #ff4600;
        background-color: #ff4600;
        color: #fff;

        .icon-arrow svg path {
          stroke: #fff;
        }
      `;
    }
    if (props.$type === 'dropdown') {
      return css`
        border: 1px solid #555;
        background-color: #fff;
        color: #000;

        .text {
          min-width: initial !important;
        }

        .icon-arrow {
          margin-left: 4px;

          svg {
            vertical-align: top;
          }
        }
      `;
    }
    if (props.$type === 'shortcut') {
      return css`
        width: 100%;
        background: #000;
        color: #fff;

        .text {
          min-width: initial !important;
        }

        .icon-arrow svg {
          vertical-align: middle;

          path {
            stroke: #fff;
          }
        }

        &[disabled] {
          opacity: 1;
        }
      `;
    }
    if (props.$type === 'refresh') {
      return css`
        .icon-refresh {
          height: 17px;
          margin-right: 8px;
        }
      `;
    }
    if (props.$type === 'transparentWhite') {
      return css`
        background: transparent;
        border-color: #fff;
        color: #fff;
      `;
    }
    if (props.$type === 'grayDropdown') {
      return css`
        background-color: #f6f6f6;
        color: #000;
        border-radius: 6px;

        .text {
          font-weight: 400;
        }

        .icon-arrow {
          margin-left: 4px;

          svg {
            vertical-align: top;
          }
        }
      `;
    }
    return null;
  }}

  &.btn-section-more {
    /* min-width: 186px; */
    margin-top: 32px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    height: ${mixin.pxToVw('40')};
    padding: ${mixin.pxToVw('0 20')};

    .text {
      font-size: ${mixin.pxToVw('14')};
      min-width: ${mixin.pxToVw('130')};
    }

    .icon-arrow {
      margin-left: ${mixin.pxToVw('7')};
    }

    .icon-before + .text {
      margin-left: ${mixin.pxToVw('10')};
    }

    .icon-after {
      margin-left: ${mixin.pxToVw('4')};
    }

    .area-ellipsis {
      max-width: ${mixin.pxToVw('114')};
    }

    ${props => {
      if (props.$size === 'large') {
        return css`
          height: ${mixin.pxToVw('50')};
          padding: ${mixin.pxToVw('0 40')};

          .text {
            font-size: ${mixin.pxToVw('15')};
            min-width: ${mixin.pxToVw('255')};
          }

          .icon-arrow {
            margin-left: ${mixin.pxToVw('9')};
          }
        `;
      }
      return null;
    }}

    ${props => {
      if (props.$type === 'lineDropdown') {
        return css`
          width: ${mixin.pxToVw('170')};

          .icon-arrow {
            width: ${mixin.pxToVw('14')};
            height: ${mixin.pxToVw('14')};
            margin-left: ${mixin.pxToVw('2')};
          }
        `;
      }
      if (props.$type === 'blackLineIcon') {
        return css`
          .icon-arrow svg {
            width: ${mixin.pxToVw('7')};
            height: ${mixin.pxToVw('10')};
          }
        `;
      }
      if (props.$type === 'grayLineIcon') {
        return css`
          .icon-arrow {
            margin-left: ${mixin.pxToVw('7')};

            svg {
              width: ${mixin.pxToVw('6')};
              height: ${mixin.pxToVw('9')};
            }
          }
        `;
      }
      if (props.$type === 'dropdown') {
        return css`
          .icon-arrow {
            margin-left: ${mixin.pxToVw('4')};

            svg {
              width: ${mixin.pxToVw('20')};
              height: ${mixin.pxToVw('20')};
            }
          }
        `;
      }
      if (props.$type === 'shortcut') {
        return css`
          .icon-arrow svg {
            width: ${mixin.pxToVw('7')};
            height: ${mixin.pxToVw('10')};
          }
        `;
      }
      if (props.$type === 'refresh') {
        return css`
          .icon-refresh {
            height: ${mixin.pxToVw('17')};
            margin-right: ${mixin.pxToVw('8')};

            svg {
              width: ${mixin.pxToVw('17')} !important;
              height: ${mixin.pxToVw('17')} !important;
            }
          }
        `;
      }
      if (props.$type === 'grayDropdown') {
        return css`
          border-radius: ${mixin.pxToVw('6')};

          .icon-arrow {
            margin-left: ${mixin.pxToVw('4')};

            svg {
              width: ${mixin.pxToVw('20')};
              height: ${mixin.pxToVw('20')};
            }
          }
        `;
      }
      return null;
    }}

    &.btn-section-more {
      /* min-width: ${mixin.pxToVw('186')}; */
      margin-top: ${mixin.pxToVw('32')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    height: 48px;
    padding: 0 20px;

    .text {
      font-size: 16px;
      min-width: 170px;
    }

    .area-ellipsis {
      display: inline-block;
      max-width: none;
    }

    ${props => {
      if (props.$size === 'large') {
        return css`
          height: 56px;

          .text {
            font-size: 17px;
            min-width: 255px;
          }
        `;
      }
      return null;
    }}

    ${props => {
      if (props.$type === 'lineDropdown') {
        return css`
          .icon-arrow {
            width: 20px;
            height: 20px;
            margin-left: 5px;
          }
        `;
      }
      if (props.$type === 'grayLineIcon') {
        return css`
          .text {
            min-width: unset;
          }

          .icon-arrow {
            margin-left: 14px;

            svg {
              width: 8px;
              height: 14px;
            }
          }
        `;
      }
      if (props.$type === 'refresh') {
        return css`
          .icon-refresh {
            width: 17px;
            height: 17px;
            margin-right: 10px;

            svg {
              width: 17px;
              height: 17px;
            }
          }
        `;
      }
      return null;
    }}

    &.btn-section-more {
      margin-top: 48px;
      width: 430px;
      min-width: unset;
    }
  }
`;
